import AWS from 'aws-sdk'

AWS.config.update({
  region: 'us-west-2',
  // accessKeyId: 'AKIAV5QFI7MC7ENKMPMD',
  accessKeyId: 'AKIAV5QFI7MCQ6CFER64',
  // secretAccessKey: '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', // TODO: Move this to ENV
  secretAccessKey: 'DtvEmBYv1nN7UjRMdEcDjQjhlDa4TUaa5HUZW8bq', // TODO: Move this to ENV
})

const s3 = new AWS.S3()

export const uploadMedia = async (
  key: string,
  media: any
): Promise<boolean> => {
  const uploadParams = {
    Bucket: 'nalapod-post-scheduling',
    Key: key,
    Body: media,
  }
  let returnStatement = false
  await s3
    .upload(uploadParams, function (err: Error) {
      if (err) {
        console.log('Error uploading file:', err)
      } else {
        console.log('Uploaded file.')
      }
    })
    .promise()
    .then(() => {
      returnStatement = true
    })
  return returnStatement
}
